/* eslint-disable import/prefer-default-export */
import { makeEntityScaffold } from '@classpass/saga-tools';
export var fitnessDeviceTracking = makeEntityScaffold('SAGA.API.FITNESS_DEVICE_TRACKING', function (client, deviceInfo) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  return client.fitness.trackDevice(deviceInfo, options).then(function (data) {
    return data.fitness_device_id;
  });
});